export default "__VITE_ASSET__Dvp1SBGd__"